import { Component } from '@angular/core';

import '../../prism/prism.js';
import { LanguageSettings } from '../../providers/languageSettings.service';

declare var Prism;

@Component({
  selector: 'app-example-cashlessedge-module',
  templateUrl: './example-cashlessedge-module.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})

/**
 * Class holding the example snippets for Cashless features.
 */
export class ExampleCashlessEdgeComponent {


/**
 * Purchase chips
 */
JavaPurchaseChipsPrism:string;
JavaPurchaseChips:string = "\
public void onPurchaseChipsClicked(View v){\n\
  \n\
  SGConnectEdge.purchaseChips(MyActivity.this, mCardNumber, mAmountInCents \n\
    mPatronName, new SGFundTransferCallback() {\n\
      @Override \n\
      public void onTransferComplete() {\n\
        Toast.makeText(MainActivity.this,\"Buy chips complete\",Toast.LENGTH_LONG).show(); \n\
\n\
      }\n\
      \n\
      @Override\n\
      public void onError(SGError transferError) {\n\
          Log.e(\"TAG\", \"TRANFER ERROR: \" + transferError.getErrorType());\n\
      }\n\
\n\
  });\n\
}";

SwiftPurchaseChipsPrism:string;
SwiftPurchaseChips:string = '\
SGConnectEdge.purchaseChips(forAccountNumber: accNumberTextfield.text!,\n\
  ofPatron: patronNameTextField.text!,\n\
  withAmountInCents: UInt32(amountTextfield.text!)!,\n\
  onTransactionComplete: onTransactionComplete)\n\
\n\
func onTransactionComplete(error: SGError?) -> Void {\n\
  if error !=  nil {\n\
    print("Transaction failed error received \\(error!.type)")\n\
  } else {\n\
    print("Transaction completed")\n\
  }\n\
}';

DartPurchaseChipsPrism:string;
DartPurchaseChips:string = "tbd";


/**
 * SELL CHIPS
 */
JavaSellChipsPrism:string;
JavaSellChips:string = "\
SGConnectEdge.sellChips(MyActivity.this, mCardNumber, \n\
    mAmountInCents, \n\
    mPatronName, new SGFundTransferCallback() {\n\
    @Override\n\
    public void onTransferComplete() {\n\
        Log.i(\"TAG\", \"Chips sale completed\");\n\
        \n\
    }\n\
    \n\
    @Override\n\
    public void onError(final SGError transferError) {\n\
        Log.e(\"TAG\", \"TRANSFER ERROR: \" + transferError.getErrorType());\n\
    }\n\
    \n\
});";

SwiftSellChipsPrism:string;
SwiftSellChips:string =  '\
SGConnectEdge.sellChips(forAccountNumber: accNumberTextfield.text!, \n\
  ofPatron: patronNameTextField.text!, withAmountInCents: UInt32(amountTextfield.text!)!,\n\
  onTransactionComplete: onTransactionComplete)\n\
\n\
func onTransactionComplete(error: SGError?) -> Void {\n\
  if error !=  nil {\n\
    print("Transaction failed error received \\(error!.type)")\n\
  } else {\n\
    print("Transaction completed")\n\
  }\n\
}';

DartSellChipsPrism:string;
DartSellChips:string = "tbd"

/**
 * ACCEPT TRANSFER
 */
JavaAcceptTransferPrism:string;
JavaAcceptTransfer:string = "\
SGConnectEdge.acceptTransfer(MyActivity.this, mCardNumber, \n\
  mPatronName, new SGFundTransferCallback() {\n\
  @Override\n\
  public void onTransferComplete() {\n\
      Log.i(\"TAG\", \"Chips transaction completed\");\n\
      \n\
  }\n\
  \n\
  @Override\n\
  public void onError(final SGError transferError) {\n\
      Log.e(\"TAG\", \"TRANSFER ERROR: \" + transferError.getErrorType());\n\
  }\n\
  \n\
});";

SwiftAcceptTransferPrism: string;
SwiftAcceptTransfer = '\
  SGConnectEdge.acceptTransfer(forAccountNumber: accNumberTextfield.text!, \n\
    ofPatron: patronNameTextField.text!,\n\
    onTransactionComplete: onTransactionComplete)\n\
  \n\
  func onTransactionComplete(error: SGError?) -> Void {\n\
    if error !=  nil {\n\
      print("Transaction failed error received \\(error!.type)")\n\
    } else {\n\
      print("Transaction completed")\n\
    }\n\
  }';

DartAcceptTransferPrism:string;
DartAcceptTransfer:string = "tdb";

/**
 * ACCEPT TRANSFER
 */
JavaObserverBlePrism:string;
JavaObserverBle:string = "\
SGConnectEdge.addObserver(new SGBleObserver() { \n\
  @Override\n\
  public void update(Enum status) {\n\
      Log.i(\"TAG\", \"BLE status change:\" + status.name());\n\
      \n\
  }\n\
  \n\
  @Override\n\
  public void onError(final SGError error) {\n\
      Log.e(\"TAG\", \"BLE ERROR: \" + error.getErrorType());\n\
  }\n\
  \n\
});";

SwiftObserverBlePrism: string;
SwiftObserverBle = '\
  SGConnectEdge.addObserver(onStateChange: onBleConnectionStateChange) \n\
  \n\
  func onBleConnectionStateChange(state: SGBLEConnectionState, error: SGError?) -> Void {\n\
    if error !=  nil {\n\
      print("BLE error received \\(error!.type)")\n\
    } else {\n\
      print("\(state)")\n\
    }\n\
  }';

DartObserverBlePrism:string;
DartObserverBle:string = "tdb";


  constructor(public languageSettings: LanguageSettings) {
    this.applyPrism();
  }

  applyPrism() {
    this.JavaSellChipsPrism = Prism.highlight(this.JavaSellChips, Prism.languages.java);
    this.JavaPurchaseChipsPrism = Prism.highlight(this.JavaPurchaseChips, Prism.languages.java);
    this.JavaAcceptTransferPrism = Prism.highlight(this.JavaAcceptTransfer, Prism.languages.java);
    this.JavaObserverBlePrism = Prism.highlight(this.JavaObserverBle, Prism.languages.java);

    this.SwiftSellChipsPrism = Prism.highlight(this.SwiftSellChips, Prism.languages.swift);
    this.SwiftPurchaseChipsPrism = Prism.highlight(this.SwiftPurchaseChips, Prism.languages.swift);
    this.SwiftAcceptTransferPrism = Prism.highlight(this.SwiftAcceptTransfer, Prism.languages.swift);
    this.SwiftObserverBlePrism = Prism.highlight(this.SwiftObserverBle, Prism.languages.swift);

    this.DartPurchaseChipsPrism = Prism.highlight(this.DartPurchaseChips, Prism.languages.javascript);
    this.DartSellChipsPrism = Prism.highlight(this.DartSellChips, Prism.languages.javascript);
    this.DartAcceptTransferPrism = Prism.highlight(this.DartAcceptTransfer, Prism.languages.javascript);
    this.DartObserverBlePrism = Prism.highlight(this.DartObserverBle, Prism.languages.javascript);

  }

}
